import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/layout/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "Home",
        meta: {
          requireAuth: true,
        },
        component: (resolve) => require(["@/views/home/index.vue"], resolve),
      }
    ],
  },
  {
    path: '/aboutUs',
    component: Layout,
    meta: {
      title: '关于西检',
    },
    children: [
      {
        path: '/aboutUs/culture',
        name: 'Culture',
        component: () => import('@/views/aboutUs/culture.vue'),
        meta: {
          title: '企业文化',
        }
      },
      {
        path: '/aboutUs/honor',
        name: 'Honor',
        component: () => import('@/views/aboutUs/honor.vue'),
        meta: {
          title: '企业荣誉',
        }
      },
      {
        path: '/aboutUs/development',
        name: 'Development',
        component: () => import('@/views/aboutUs/development.vue'),
        meta: {
          title: '发展历程',
        }
      },
      {
        path: '/aboutUs/groupProfile',
        name: 'GroupProfile',
        component: () => import('@/views/aboutUs/groupProfile.vue'),
        meta: {
          title: '集团简介',
        }
      },
      {
        path: '/aboutUs/workstation',
        name: 'Workstation',
        component: () => import('@/views/aboutUs/workstation.vue'),
        meta: {
          title: '院士工作站',
        }
      },
      // {
      //   path: '/aboutUs/subsidiary',
      //   name: 'Subsidiary',
      //   component: () => import('@/views/aboutUs/subsidiary.vue'),
      //   meta: {
      //     title: '集团子公司简介',
      //   }
      // },
      {
        path: '/aboutUs/digit',
        name: 'Digit',
        component: () => import('@/views/aboutUs/child/digit.vue'),
        meta: {
          title: '西检数字',
        }
      },
      {
        path: '/aboutUs/ecology',
        name: 'Ecology',
        component: () => import('@/views/aboutUs/child/ecology.vue'),
        meta: {
          title: '西检生态',
        }
      },
      {
        path: '/aboutUs/shanxi',
        name: 'Shanxi',
        component: () => import('@/views/aboutUs/child/shanxi.vue'),
        meta: {
          title: '西部第三方检测集团（陕西）公司',
        }
      },
      {
        path: '/aboutUs/ningxia',
        name: 'Ningxia',
        component: () => import('@/views/aboutUs/child/ningxia.vue'),
        meta: {
          title: '西部第三方检测集团（宁夏）公司',
        }
      },
      {
        path: '/aboutUs/training',
        name: 'Training',
        component: () => import('@/views/aboutUs/child/training.vue'),
        meta: {
          title: '陕西西检技术标准化培训中心',
        }
      },
      {
        path: '/aboutUs/survey',
        name: 'Survey',
        component: () => import('@/views/aboutUs/child/survey.vue'),
        meta: {
          title: '陕西西检地质文物勘察技术有限公司',
        }
      },
    ]
  },
  {
    path: '/information',
    component: Layout,
    meta: {
      title: '西检资讯',
    },
    children: [
      {
        path: '/information/specialTopic',
        name: 'SpecialTopic',
        component: () => import('@/views/information/specialTopic.vue'),
        meta: {
          title: '专题专栏',
        }
      },
      {
        path: '/information/groupDynamics',
        name: 'GroupDynamics',
        component: () => import('@/views/information/groupDynamics.vue'),
        meta: {
          title: '集团动态',
        }
      },
      {
        path: '/information/industryNews',
        name: 'IndustryNews',
        component: () => import('@/views/information/industryNews.vue'),
        meta: {
          title: '行业动态',
        }
      },
      {
        path: '/information/industryKnowledge',
        name: 'IndustryKnowledge',
        component: () => import('@/views/information/industryKnowledge.vue'),
        meta: {
          title: '行业知识',
        }
      },
      {
        path: '/information/newsDetails',
        name: 'newsDetails',
        component: () => import('@/views/information/newsDetails.vue'),
        meta: {
          title: '西检资讯-详情',
        }
      },
    ]
  },
  {
    path: '/products',
    component: Layout,
    meta: {
      title: '产品与服务',
    },
    children: [
      {
        path: '/products/environment',
        name: 'Environment',
        component: () => import('@/views/products/environment.vue'),
        meta: {
          title: '生态业务',
        }
      },
      {
        path: '/products/digit',
        name: 'Digit',
        component: () => import('@/views/products/digit.vue'),
        meta: {
          title: '数字业务',
        }
      },
      {
        path: '/products/detection',
        name: 'Detection',
        component: () => import('@/views/products/detection.vue'),
        meta: {
          title: '检测业务',
        }
      },
      {
        path: '/products/training',
        name: 'Training',
        component: () => import('@/views/products/training.vue'),
        meta: {
          title: '培训业务',
        }
      },
      {
        path: '/products/survey',
        name: 'Survey',
        component: () => import('@/views/products/survey.vue'),
        meta: {
          title: '勘探业务',
        }
      },
    ]
  },
  {
    path: '/resources',
    component: Layout,
    meta: {
      title: '人力资源',
    },
    children: [
      {
        path: '/resources/talentConcept',
        name: 'TalentConcept',
        component: () => import('@/views/resources/talentConcept.vue'),
        meta: {
          title: '人才理念',
        }
      },
      {
        path: '/resources/recruitingPlan',
        name: 'RecruitingPlan',
        component: () => import('@/views/resources/recruitingPlan.vue'),
        meta: {
          title: '招聘计划',
        }
      },
      {
        path: '/resources/hireList',
        name: 'hireList',
        component: () => import('@/views/resources/hireList.vue'),
        meta: {
          title: '招聘计划-列表',
        }
      },
      {
        path: '/resources/hireDetails',
        name: 'hireDetails',
        component: () => import('@/views/resources/hireDetails.vue'),
        meta: {
          title: '招聘计划-详情',
        }
      },
    ]
  },
  {
    path: '/results',
    component: Layout,
    children: [
      {
        path: '/results',
        name: 'Results',
        component: () => import('@/views/results/index.vue'),
        meta: {
          title: '全局搜索',
        }
      },
    ]
  },
];

const router = new VueRouter({
  routes,
});

// 避免重复路由跳转报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;
